import { render, staticRenderFns } from "./ConfirmPostAllPayments.vue?vue&type=template&id=516965b3&"
import script from "./ConfirmPostAllPayments.vue?vue&type=script&lang=js&"
export * from "./ConfirmPostAllPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports